import { createSelector } from 'reselect'

const qsSelector = state => state.qs

export default createSelector(
	[qsSelector],
	qsSelectorData => ({
		fromLTI: qsSelectorData.fromLTI,
		referer: qsSelectorData.referer,
	})
)
